import * as z from "zod";

export const NewPasswordSchema = z
  .object({
    password: z.string().min(6, {
      message: "Minimum 6 characters required",
    }),
    confirmPassword: z.string().min(6, "Confirm password is required"),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        path: ["confirmPassword"],
        message: "Passwords do not match",
        code: z.ZodIssueCode.custom,
      });
    }
  });

export const ResetSchema = z.object({
  email: z.string().email({
    message: "Email is required",
  }),
  recaptchaToken: z.string().min(1, "ReCAPTCHA validation failed"),
});

export const ResetSchemaEmail = z.object({
  email: z.string().email({
    message: "Email is required",
  }),
});

export const LoginSchema = z.object({
  email: z.string().email({
    message: "Email is required",
  }),
  password: z.string().min(1, {
    message: "Password is required",
  }).max(20, {
    message: "Password cannot be longer than 20 characters",
  }),
  code: z.optional(z.string()),
});

export const RegisterSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Minimum 6 characters required").max(20, {
    message: "Password cannot be longer than 20 characters",
  }),
  // agreeToTerms: z.boolean().refine((val) => val === true, {
  //   message: "You must agree to the Privacy Policy and Terms of Service",
  // }),
  // recaptchaToken: z.string().min(1, "ReCAPTCHA validation failed"),
});

export const AffiliateSchema = z.object({
 name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Minimum 6 characters required").max(20, {
    message: "Password cannot be longer than 20 characters",
  }),
  // agreeToTerms: z.boolean().refine((val) => val === true, {
  //   message: "You must agree to the Privacy Policy and Terms of Service",
  // }),
  // recaptchaToken: z.string().min(1, "ReCAPTCHA validation failed"),
});
